export { default } from './ComponentReplacer';
